export const AUTH_APP = 'AUTH_APP';
export const AUTH_DEBUG = "AUTH_DEBUG";
export const AUTH_CREATE_APP = "AUTH_CREATE_APP";
export const AUTH_EDIT_APP = "AUTH_EDIT_APP";
export const AUTH_REMOVE_APP = "AUTH_REMOVE_APP";
